import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
  MatLegacyDialogModule,
} from '@angular/material/legacy-dialog';
import { TranslateModule } from '@ngx-translate/core';
import { DummyFollowButtonComponent } from '@shared/shared/components/dummy-follow-button/dummy-follow-button.component';

@Component({
  selector: 'ten-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, DummyFollowButtonComponent, MatLegacyButtonModule, MatLegacyDialogModule, MatIconModule],
})
export class ConfirmationPopupComponent {
  public artistName: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private dialogRef: MatDialogRef<ConfirmationPopupComponent>
  ) {
    this.artistName = '<b class="popup-artist-bold">' + data.artist + '</b>';
  }

  public close() {
    this.dialogRef.close();
  }
}
